module.exports = __webpack_public_path__ + "static/media/DownBad.fab89c2b.png";